"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuantityPicker = useQuantityPicker;
var _react = require("react");
var QuantityPickerClick = _interopRequireWildcard(require("./QuantityPickerClickEvent"));
var _useControlledQuantityPicker = require("./useControlledQuantityPicker");
var _useDebug = require("./useDebug");
var _useUncontrolledQuantityPicker = require("./useUncontrolledQuantityPicker");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Use QuantityPicker - logic for QuantityPicker with increase and decrease events
 * Can be uses with controlled or uncontrolled manner
 * @param {UseQuantityPickerProps} props
 */
function useQuantityPicker(props) {
  const autoId = (0, _react.useId)();
  const {
    id = autoId,
    InputProps,
    value,
    visibilityTriggerClicked = false
  } = props;
  const [lastIncreased, setLastIncreased] = (0, _react.useState)('');
  const [loadOnClick, setLoadOnClick] = (0, _react.useState)(visibilityTriggerClicked);
  const {
    log
  } = (0, _useDebug.useDebug)(`ID-${id}`);
  const triggerClickEvent = (0, _react.useCallback)(identifier => {
    const event = new CustomEvent(QuantityPickerClick.Name, {
      detail: {
        id: identifier
      }
    });
    window.dispatchEvent(event);
  }, []);

  /** Called on clickAway to reset lastIncreased when clicking on other lickers and/or other links */
  const resetLastIncreased = (0, _react.useCallback)(source => {
    log(source, 'reset tooltip triggers');
    setLastIncreased('');
    setLoadOnClick(false);
  }, [log]);
  const handleKeyDown = (0, _react.useCallback)(({
    currentTarget,
    key
  }) => {
    if (key === 'Enter') {
      currentTarget.blur();
    }
  }, []);

  /** Set last increased for newly initiated.
   * In case that the value is set to zero, on next increase will be set as newly initiated again.
   */
  (0, _react.useEffect)(() => {
    if (loadOnClick && typeof value === 'number' && value === 1) {
      setLastIncreased(id);
    }
    triggerClickEvent(id);
    setLoadOnClick(false);
  }, [id, loadOnClick, triggerClickEvent, value]);
  const onQuantityPickerClickListener = event => {
    if (event.detail.id !== id) {
      resetLastIncreased(`action on ${event.detail.id} ➡️`);
    }
  };
  (0, _react.useEffect)(() => {
    window.addEventListener(QuantityPickerClick.Name, onQuantityPickerClickListener);
    return () => {
      window.removeEventListener(QuantityPickerClick.Name, onQuantityPickerClickListener);
    };
  });
  const innerProps = {
    ...props,
    id,
    loadOnClick,
    log,
    setLastIncreased,
    triggerClickEvent
  };
  const {
    current: isControlled
  } = (0, _react.useRef)(value != null);
  const controlled = (0, _useControlledQuantityPicker.useControlledQuantityPicker)(innerProps);
  const uncontrolled = (0, _useUncontrolledQuantityPicker.useUncontrolledQuantityPicker)(innerProps);
  const logBase = (0, _react.useMemo)(() => {
    const increase = lastIncreased === id ? '🟢LAST INCREASED' : '🟡';
    const opened = visibilityTriggerClicked && loadOnClick ? '🆕 LAST OPENED' : '';
    return [increase, opened];
  }, [id, lastIncreased, loadOnClick, visibilityTriggerClicked]);
  if (isControlled) {
    return {
      ...controlled,
      InputProps: {
        ...InputProps
      },
      lastIncreased,
      handleKeyDown,
      logBase
    };
  }
  return {
    ...uncontrolled,
    InputProps: {
      ...InputProps
    },
    lastIncreased,
    handleKeyDown,
    logBase
  };
}
//# sourceMappingURL=useQuantityPicker.js.map